import React from 'react';
import data from '../../programs.json';

const { howProgramWorks } = data;

const HowProgramWorks = () => {
  const { id, heading, steps } = howProgramWorks;

  return (
    <section id={id} className="w-full bg-white ava-section-gap">
      <div className="container mx-auto px-4 md:px-8">

        {/* ── Heading ── */}
        <h2
          className="text-center ava-heading-gap ava-heading-md"
        >
          {heading}
        </h2>

        {/* ── Wrapper: icons row + divider line + text row ── */}
        <div className="w-full">

          {/* ── Icons row ── */}
          <div className="grid grid-cols-2 lg:grid-cols-4">
            {steps.map((step) => (
              <div key={step.id} className="flex justify-center pb-6">
                <div className="relative flex-shrink-0">
                  {/* Main navy circle */}
                  <div
                    className="w-20 h-20 rounded-full  flex items-center justify-center"
                    style={{ backgroundColor: 'var(--secondary-color)', 
                    }}
                  >
                    <img
                      src={step.icon}
                      alt={step.title}
                      className="w-9 h-9"
                      style={{ filter: 'brightness(0) invert(1)' }}
                      draggable={false}
                    />
                  </div>
                  {/* Step number badge */}
                  <div
                    className="absolute -top-1 -right-1 w-7 h-7 rounded-full flex items-center justify-center ava-border border-white ava-card-bg"
                    style={{
                      fontSize: '0.65rem',
                      border:"1px solid black"

                    }}
                  >
                    {String(step.number).padStart(2, '0')}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Full-width horizontal divider below all icons ── */}
          <div
            className="w-full h-px mb-8"
            style={{ backgroundColor: 'var(--ava-color-black)' }}
          />

          {/* ── Text row ── */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-8">
            {steps.map((step) => (
              <div key={step.id} className="flex flex-col items-center text-center px-3 md:px-5 gap-2">
                <h3
                  className=" ava-text-subheading  "
                  // style={{ color: 'var(--primary-color)' }}
                >
                  {step.title}
                </h3>
                <p
                  className="ava-text-sm"
                >
                  {step.description}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default HowProgramWorks;